import { KYMW0901Model } from '../kymw0901.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 供給計画取得クラス
 *
 * @export RenewPlanGoodsChangeService
 * @class RenewPlanGoodsChangeService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class RenewPlanGoodsChangeService extends PlessJsonResponderSub<any> {

  // VO
  private model: KYMW0901Model = new KYMW0901Model;
  private vo = null;
  // 処理に使用するModel
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @param model 処理に使用するモデル
   * @param vo vo
   * @param successFunc 成功時に実行される処理
   * @memberof RenewPlanGoodsChangeService
   */
  execute(model: KYMW0901Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW09renewPlanGoodsChangeManage', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RenewPlanGoodsChangeService
   */
  success(data: any): void {
  }

  /**
   * 更新完了後の後処理でエラーが発生
   *
   * @param {string} status
   * @param {*} result
   * @memberof RenewPlanGoodsChangeService
   */
  public exceptionError(status: string, result: any): void {
    this.dialogService.openAlertGetMessage('E0236', null, () => {
      this.closeKYMW0900Handler();
    });
  }

  /**
   * 商品企画メンテナンスを終了する
   *
   * @memberof RenewPlanGoodsChangeService
   */
  public closeKYMW0900Handler(): void {
    // 企画メンテ画面、変更確認画面を閉じる。
    this.model.kymw0901Component.closeFunction(true);
  }
}
